/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */

import { Box, Typography } from '@mui/material';
import { FC } from 'react';

export type CounterSlideType = {
	selectedNumber?: number;
	totalSlides?: number;
};

export const CounterSlides: FC<{ selectedNumber?: number; totalSlides?: number }> = ({
	selectedNumber,
	totalSlides,
}) => (
	<Box
		sx={{
			position: 'absolute',
			bottom: '18px',
			right: '19px',
			px: '11px',
			py: '4px',
			backgroundColor: '#000000',
			opacity: '0.7',
			borderRadius: '13px',
		}}
	>
		<Typography
			sx={{ color: '#FFFFFF', fontSize: 'var(--font-size-small)', fontWeight: '600', fontFamily: 'Open Sans' }}
		>
			{selectedNumber}
			{'/'}
			{totalSlides}
		</Typography>
	</Box>
);
